import { useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * La ranura de la barra superior donde se dibujan la ayuda (recorrido guiado) y
 * «Reportar un problema».
 *
 * Antes eran botones flotantes abajo a la derecha, apilados encima del
 * contenido: tapaban la última columna de las tablas (fechas, acciones) y la
 * paginación. En la barra quedan al lado del tema y las notificaciones, con el
 * mismo tamaño, y no tapan nada.
 *
 * Los que se dibujan acá viven en otro lado del árbol (el proveedor del
 * recorrido, el marco), así que entran por un portal. Sin barra (una prueba que
 * monta el botón suelto) se dibujan donde están, como siempre.
 */
export const ID_RANURA_DE_AYUDA = 'ranura-de-ayuda';

export function RanuraDeAyuda() {
  return <div id={ID_RANURA_DE_AYUDA} className="contents" />;
}

/** El nodo de la ranura, una vez que la barra está montada. */
function useNodoDeLaRanura(): HTMLElement | null {
  const [nodo, setNodo] = useState<HTMLElement | null>(null);
  useEffect(() => {
    setNodo(document.getElementById(ID_RANURA_DE_AYUDA));
  }, []);
  return nodo;
}

/**
 * Dibuja `enLaBarra` dentro de la ranura si existe; si no, `sinBarra`.
 */
export function EnLaRanuraDeAyuda({
  enLaBarra,
  sinBarra,
}: {
  enLaBarra: ReactNode;
  sinBarra: ReactNode;
}) {
  const nodo = useNodoDeLaRanura();
  return nodo ? createPortal(enLaBarra, nodo) : <>{sinBarra}</>;
}
